import { Link, useLocation } from 'react-router-dom';
import { usePageMeta } from '@/hooks/usePageMeta';

export default function NotFound() {
  const location = useLocation();
  usePageMeta('页面未找到 - 日韩中文字幕', '抱歉，你访问的页面不存在，请返回首页继续浏览日韩影视中文字幕资源。');

  return (
    <div className="mx-auto flex w-full max-w-[1240px] flex-col items-center px-4 py-24 text-center md:px-8 lg:px-10">
      <span className="font-heading text-7xl font-extrabold text-primary-200 md:text-9xl">404</span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">页面不存在</h1>
      <p className="mt-3 text-sm text-foreground-500">
        抱歉，你访问的地址 <span className="font-mono text-foreground-700">{location.pathname}</span> 暂时没有内容。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex h-11 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex h-11 items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
        >
          <i className="ri-search-line"></i>
          搜索字幕
        </Link>
      </div>
    </div>
  );
}